import { createFileRoute } from '@tanstack/react-router';
import { SwitchView } from '@/modules/auth';
import { PageMetadata } from '@/app/PageMetadata';
import { first } from '@/app/searchSerialization';

const parsePositiveInt = (value: string | undefined): number | null => {
  if (value == null) {
    return null;
  }

  const parsed = Number(value);

  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const Route = createFileRoute('/switch')({
  validateSearch: (search: Record<string, unknown>) => ({
    userId: parsePositiveInt(first(search.userId)),
    locationId: parsePositiveInt(first(search.locationId)) ?? undefined,
    returnUrl: first(search.returnUrl) ?? null,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { userId, locationId, returnUrl } = Route.useSearch();

  return (
    <>
      <PageMetadata title="Switching Account | Self Inspection" />
      <SwitchView userId={userId} locationId={locationId} returnUrl={returnUrl} />
    </>
  );
}
